import { PurchaseFlow as brazilPurchaseFlow } from './brazil/components/PurchaseFlow'
import caPurchaseFlow from './canada/components/PurchaseFlow'

const purchaseFlows = {
    CA: caPurchaseFlow,
    BR: brazilPurchaseFlow,
}

export const PurchaseFlow = purchaseFlows[window.COUNTRY_PURCHASE_FLOW]
